export const INSTALLATION_GUIDE = {
  pdfUrl: '/docs/Manual_Instalacao_SysMV_R1.pdf',
  pdfLabel: 'Baixar manual PDF',
  youtubeUrl: 'https://www.youtube.com/watch?v=UXU4Au4TJwY',
  youtubeLabel: 'Assistir no YouTube',
  title: 'Guia de instalação do dispositivo físico',
  description:
    'Siga o passo a passo no vídeo ou no manual em PDF para parear, conectar ao Wi-Fi e colocar seu Sys[mv] R01 em operação.',
}

export const FAQ_ITEMS = [
  {
    id: 'add-device',
    category: 'Dispositivo',
    question: 'Como adiciono um novo dispositivo?',
    answer:
      'Vá para a tela de "Ajustes", clique no botão "Adicionar Novo Dispositivo" e siga as instruções para escanear o QR Code ou inserir o ID do seu dispositivo manualmente.',
  },
  {
    id: 'offline',
    category: 'Dispositivo',
    question: "Meu dispositivo aparece como 'Offline'. O que eu faço?",
    answer: "Um status 'Offline' geralmente indica um problema de conexão. Verifique os seguintes pontos:",
    bullets: [
      'O dispositivo está ligado na tomada?',
      'A rede Wi-Fi à qual ele está conectado está funcionando?',
      'O sinal de Wi-Fi é forte o suficiente no local de instalação?',
    ],
    footer: 'Se o problema persistir, tente reiniciar o dispositivo e seu roteador.',
  },
  {
    id: 'notifications',
    category: 'Notificações',
    question: 'Como as notificações funcionam?',
    answer:
      'O aplicativo envia notificações push para o seu navegador quando eventos importantes ocorrem, como níveis de água atingindo os limites que você configurou. Para recebê-las, você precisa autorizar as notificações quando o navegador solicitar.',
  },
  {
    id: 'estimated-duration',
    category: 'Consumo',
    question: "A 'Duração Estimada' não parece correta. Por quê?",
    answer:
      'A estimativa de duração é baseada no seu consumo médio histórico. Se seu padrão de uso mudou recentemente, pode levar alguns dias para que a estimativa se ajuste à nova realidade.',
  },
  {
    id: 'total-cost',
    category: 'Consumo',
    question: "Como o 'Custo Total' é calculado?",
    answer:
      'O custo utiliza um cálculo progressivo baseado nas tarifas que você define nos Ajustes. Ele considera uma taxa mínima fixa para o consumo básico e um valor por metro cúbico (m³) para o que exceder esse limite.',
  },
  {
    id: 'sharing',
    category: 'Planos',
    question: 'Como funciona o compartilhamento de acesso?',
    answer:
      'Proprietários (plano Básico ou Pro) podem convidar outros usuários via e-mail na tela de Ajustes. O convidado receberá um e-mail e poderá visualizar os dados do dispositivo após aceitar o convite no próprio app.',
  },
  {
    id: 'relay-pump',
    category: 'Pro',
    question: 'O que é o controle de Relé/Bomba?',
    answer:
      'Disponível no plano Pro, permite automatizar o acionamento de bombas ou válvulas. Você pode escolher entre o modo automático (por nível), agendamento por horário ou controle manual direto no app.',
  },
  {
    id: 'tank-dimensions',
    category: 'Reservatório',
    question: 'Como configurar as dimensões do reservatório?',
    answer:
      "Em Ajustes > Reservatório, selecione o formato (Retangular, Cilíndrico ou Cônico) e insira as medidas em centímetros. O sistema calculará a capacidade total automaticamente. Não esqueça de configurar o 'Ajuste de Medição'.",
  },
  {
    id: 'anomaly-alerts',
    category: 'Alertas',
    question: 'O que são os Alertas de Anomalias?',
    answer:
      'Nossa IA monitora padrões de uso para detectar picos de consumo atípicos ou possíveis vazamentos (consumo contínuo em horários de pouco uso, como a madrugada). Este recurso requer plano Básico ou Pro (ou período de trial ativo).',
  },
  {
    id: 'export-excel',
    category: 'Pro',
    question: 'Posso exportar meus dados para o Excel?',
    answer:
      'Sim! Usuários do plano Pro podem baixar o histórico completo em formato CSV (compatível com Excel) através do botão de exportação na tela de Histórico.',
  },
  {
    id: 'zero-history',
    category: 'Dados',
    question: 'Meu histórico ou consumo está zerado em alguns dias. Por que isso acontece?',
    answer:
      'Isso geralmente ocorre se o dispositivo não enviou dados durante aquele período (perda de conexão Wi-Fi ou falhas de energia), ou se não houve mudança de volume no reservatório. Além disso, pequenas oscilações podem ser filtradas automaticamente para evitar cálculos errados.',
  },
  {
    id: 'multi-device-access',
    category: 'Acesso',
    question: 'Posso acessar meus dados de outro computador ou celular?',
    answer:
      'Sim! Como o Sys[mv] funciona em nuvem, você pode acessar seu painel de qualquer dispositivo com navegador, basta fazer o login com sua conta.',
  },
  {
    id: 'wifi-reconfig',
    category: 'Instalação',
    question: 'Como reconfigurar o Wi-Fi do dispositivo caso eu troque de roteador?',
    answer:
      'Você precisará refazer o pareamento inicial do dispositivo. Isso envolve conectá-lo via Bluetooth ou acessar a rede temporária dele, assim como na primeira instalação. Siga as instruções do nosso Canal do YouTube ou PDF de instalação.',
  },
  {
    id: 'min-max-alerts',
    category: 'Alertas',
    question: 'Como funciona a previsão e alerta de volume mínimo e máximo?',
    answer:
      "Na tela de 'Ajustes' (ícone de engrenagem), você pode definir as porcentagens de alerta de Nível Baixo e Nível Alto. O sistema vai monitorar em tempo real e te notificar caso o volume do seu reservatório rompa um desses limites.",
  },
]

export const FAQ_CATEGORIES = ['Todos', ...new Set(FAQ_ITEMS.map((item) => item.category))]
